import { type FC, memo } from 'react';

export type CloudInstanceDetailData = {
  cloudProvider: string | null;
  vmId: string | null;
  name: string | null;
  status: string | null;
  os: string | null;
  image: string | null;
  availabilityZone: string | null;
};

interface Props {
  firstColumnClassName?: string;
  secondColumnClassName?: string;
  tableClassName?: string;
  tableData: CloudInstanceDetailData;
}

const BareCloudInstanceDetailContent: FC<Props> = (props) => (
  <table className={props.tableClassName}>
    <tbody>
      <tr>
        <td className={props.firstColumnClassName}>Cloud provider</td>
        <td className={props.secondColumnClassName}>
          {props.tableData.cloudProvider}
        </td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Name</td>
        <td className={props.secondColumnClassName}>{props.tableData.name}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>VM ID</td>
        <td className={props.secondColumnClassName}>{props.tableData.vmId}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Operating system</td>
        <td className={props.secondColumnClassName}>{props.tableData.os}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Image</td>
        <td className={props.secondColumnClassName}>{props.tableData.image}</td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Status</td>
        <td className={props.secondColumnClassName}>
          {props.tableData.status}
        </td>
      </tr>
      <tr>
        <td className={props.firstColumnClassName}>Availability zone</td>
        <td className={props.secondColumnClassName}>
          {props.tableData.availabilityZone}
        </td>
      </tr>
    </tbody>
  </table>
);

export const CloudInstanceDetailContent = memo(BareCloudInstanceDetailContent);
